<div class="min-h-screen pt-4 print:pt-0">
  <!-- Title -->
  <app-card class="mt-4">
    <div class="flex justify-between w-full p-4 print:p-0">
      <h2 class="text-2xl flex justify-between items-end print:text-lg">
        <span class="material-icons-outlined leading-normal pr-1 print:hidden">
          celebration
        </span>
        Changelog
      </h2>
    </div>
  </app-card>
  <!-- Main content. -->
  <main class="grid grid-cols-2 gap-4 pt-4">
    <app-release-card *ngFor="let release of releases"
      [release]="release"> </app-release-card>
  </main>
</div>